import React, { useContext } from 'react';

import Permissions from '@/lib/permissions';
import AppPage from '@/ui/AppPage/AppPage';
import DataController from '@/lib/DataController';
import Kremirani from '@/models/groblja/kremirani';
import DCTable from '@/ui/Table/DCTable';
import DialogContext from '@/context/DialogContext/DialogContext';
import GeneralTableDialog from '@/ui/Dialog/GeneralTableDialog';
import { AllowRowActionFn } from '@/@types/ui/Table';
import { DCRecord } from '@/@types/lib/dataController';
import AdvancedGrobljaDialog from '../RegistarKorisnika/AdvancedGrobljaDialog';

const RegistarKremiranihPage = () => {
  const dc = new DataController(Kremirani);

  const { showDialog } = useContext(DialogContext);

  const handleRowAction: (action: string, id: number, record?: { [key: string]: any }) => void = (action, id) => {
    if (action === 'show_history') {
      showDialog(GeneralTableDialog, {
        mode: 'view',
        dc,
        onClose: () => {},
        level: 1,
        title: 'groblja:titles.kremirani_history',
        view: 'history',
        customPath: `${Kremirani.apiPath}/${id}/history`,
        tableId: 'kremirani-history',
      });
    }
  };

  const allowRowAction: AllowRowActionFn = (action: string, record: DCRecord) => {
    if (action === 'show_history' && record.has_history) {
      return true;
    }
    return false;
  };

  return (
    <AppPage titlett="groblja:titles.reg_kremiranih" needPermission={[Permissions.GrobljaManageRegistarKremiranih]}>
      <DCTable
        allowRowAction={allowRowAction}
        onRowAction={handleRowAction}
        dc={dc}
        title="groblja:titles.reg_kremiranih"
        allowSelection="one"
        allowAdd
        allowEdit
        // allowDelete
        allowColumnPicker
        allowFilter
        dialogComponent={AdvancedGrobljaDialog}
        allowShowDeleted
        allowDocumentButton
        allowExport
      />
    </AppPage>
  );
};

export default RegistarKremiranihPage;
